import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/**
 * This service is used to get Geopoint from an address
 * No API key is required to use Nominatim
 */
@Injectable()
export class NominatimService {

  NOMINATIM_API =  'https://nominatim.openstreetmap.org/search?q={{address}}&format=json&polygon_geojson=1&addressdetails=1';

  constructor(private http: HttpClient) { }

  search(address: string): Observable<any> {
    let url = this.NOMINATIM_API;
    url = url.replace('{{address}}', address);
    return this.http.get(encodeURI(url));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils/nominatim.service.ts